import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Calculadora from "../Pages/Calculadora/Calculadora";
import Dashboard from "../Pages/Dashboard/Dashboard";
import Declaracao from "../Pages/Declaracao/Declaracao";
import Documentos from "../Pages/Documentos/Documentos";
import Faq from "../Pages/Faq/Faq";
import { IRPF_CONFIG } from "../config/irpfConfig";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Dashboard>
        <Routes>
          <Route
            path="/*"
            element={<Navigate to={{ pathname: IRPF_CONFIG.declarationPath }} />}
          />
          <Route path={IRPF_CONFIG.declarationPath} element={<Declaracao />} />
          <Route
            path="/declaracao2025"
            element={<Navigate to={{ pathname: IRPF_CONFIG.declarationPath }} />}
          />
          <Route
            path="/declaracao"
            element={<Navigate to={{ pathname: IRPF_CONFIG.declarationPath }} />}
          />
          <Route path="/documentos" element={<Documentos />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/calculadora" element={<Calculadora />} />
        </Routes>
      </Dashboard>
    </BrowserRouter>
  );
};

export default AppRoutes;
